<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <span>{{ FSC_LICENSE_NUMBER }}</span>
</template>

<script setup lang="ts">
import { FSC_LICENSE_NUMBER } from '@cutr/constants/cutr';
</script>
